import application from './application';
import element from './element';
import screen from './screen';
export default { application, element, screen };
